<template>
  <div>
    <van-tabbar
      v-model="active"
      active-color="#007AFF"
      inactive-color="#D6D7E1"
    >
      <van-tabbar-item icon="wap-home" to="/homes">首页</van-tabbar-item>
      <van-tabbar-item icon="like" to="/Posthouse">心灵驿站</van-tabbar-item>
      <van-tabbar-item icon="smile" to="/service">心理咨询</van-tabbar-item>
      <van-tabbar-item icon="manager" to="/me">我的</van-tabbar-item>
    </van-tabbar>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
    };
  },
  watch: {
    active() {
      window.sessionStorage.setItem("active", this.active);
    },
  },

  created() {
    if (sessionStorage.getItem("active")) {
      this.active = parseInt(sessionStorage.getItem("active")) || 0
    }
  },

  mounted() {
    window.addEventListener("setItem", () => {
      this.active = parseInt(sessionStorage.getItem("active"))
    })
  },

  beforeDestroy() {
    sessionStorage.setItem("active", this.active);
    window.removeEventListener("setItem", () => {})
  },
};
</script>

<style lang="scss" scoped>
.van-tabbar--fixed {
  z-index: 1111;
}
</style>